const styles = theme => ({
  privateBlockGeneral : theme.showHtmlText,
});

export default styles;